export default __webpack_public_path__ + "static/media/you_can_save_use1.de2bda11.png";